module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/slug-input/slug-input.component.scss
// module id = ./src/app/shared/slug-input/slug-input.component.scss
// module chunks = main